__webpack_require__.p = "https://ikea.marat.qd.je/ca/en/customer-service/support/";